import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { IAppSettings } from './types';

const elements = document.querySelectorAll('.post-filters-archive');

elements.forEach((element) => {
	const root = createRoot(element);

	const apiBase = element.getAttribute('data-api-base');
	const postType = element.getAttribute('data-post-type');
	const postsPerPage = element.getAttribute('data-posts-per-page');
	const filtersToShow = element.getAttribute('data-filters-to-show');
	const showSearch = element.getAttribute('data-show-search');
	const layout = element.getAttribute('data-layout');
	const searchTitle = element.getAttribute('data-search-title');
	const selectedTax = element.getAttribute('data-selected-tax');
	const pushSelectionsToUrl = element.getAttribute('data-push-selections-to-url');

	const settings: IAppSettings = {
		apiBase: apiBase ?? '',
		postType: postType ?? 'post',
		postsPerPage: null !== postsPerPage ? +postsPerPage : 12,
		filtersToShow: filtersToShow?.length ? filtersToShow.split(',') : [],
		showSearch: !!showSearch,
		layout: layout ?? 'default',
		searchTitle: searchTitle ?? 'Search by keyword',
		initSelectedTax: null !== selectedTax ? JSON.parse(selectedTax) : {},
		pushSelectionsToUrl: !!pushSelectionsToUrl,
	};

	if (settings.apiBase.length) {
		root.render(
			<React.StrictMode>
				<App settings={settings} />
			</React.StrictMode>
		);
	}
});
